// @flow
import * as React from "react";
import {Trans} from "react-i18next";
import {BrandContext} from "./App";
import {dealerShopUrl, hostedDealerHref} from "./helper/hostedRouting";

export type Address = {
	street: string,
	postalCode: string,
	streetNumber: string,
	town: string,
}

export type DealerConfiguration = {
	leadModuleEnabled: boolean,
	productPricesDisabled: boolean,
	shopEnabled: boolean,
	shopRouting?: ?string,
}

export type DealerType = {
	name: string,
	identifier: {
		dealerNo: string,
		marketplace: any,
	},
	dealerConfiguration: DealerConfiguration,
	distance: string,
	address: Address,
	productUrl: string,
	shopBaseUrl: string,
}

type Props = { dealer: DealerType };
export const Dealer = (props: Props) => {
	const brand = React.useContext(BrandContext);
	// the dealer's hosted shop: /<language>/<brand>/<dealerId>, keeping the visitor's query
	const selectDealer = (dealerId: string) => hostedDealerHref(dealerId) + window.location.search;

	// the dealer's own shop page, addressed in the dealer's shop routing
	const selectBaseUrl = (baseUrl: string, dealerId: ?string, brand: ?string, routing: ?string) => {
		try {
			return dealerShopUrl(baseUrl, routing, brand);
		} catch (e) {
			return selectDealer(dealerId);
		}
	};

	const renderDealerAddress = () => {
		const {address} = props.dealer;
		return address
			? <React.Fragment>
                {!!address.street ? address.street : "" + !!address.streetNumber ? " " + address.streetNumber : ""} <br/>
				{address.postalCode + " " + address.town} <br/>
				{!!props.dealer.distance &&
				<small>{props.dealer.distance} {!!props.dealer.distance}<Trans i18nKey="nsc.distance"/></small>}
			</React.Fragment>
			: <React.Fragment>&nbsp;</React.Fragment>;
	};

	const dealerIcon = props.dealer.dealerConfiguration.shopEnabled
		? "dealerIcon shop"
		: props.dealer.dealerConfiguration.productPricesDisabled
			? "dealerIcon location"
			: "dealerIcon localOffer";

	return <div className={"dealer"} key={props.dealer.identifier.dealerNo}>
		<span>{props.dealer.name}</span>
		<span>{renderDealerAddress()}</span>
		<span className={dealerIcon}/>
		{
			props.dealer.shopBaseUrl
				? <a href={selectBaseUrl(props.dealer.shopBaseUrl, props.dealer.identifier.dealerNo, brand, props.dealer.dealerConfiguration.shopRouting)}><Trans i18nKey="nsc.visitGarage"/> </a>
				: <a href={selectDealer(props.dealer.identifier.dealerNo)}><Trans i18nKey="nsc.visitGarage"/> </a>
		}
	</div>;
};
